/* FLIPSI · Chooser v2 · two routes (front / surprise), data-driven.
   Reads config from script[data-chv2-data] inside [data-flipsi-chv2].
   Exposes window.__fsChooserOpen so the worlds-rail chooser-trigger opens it.
   Engine rules (locked in the approved final candidate):
   - feeling AND intensity ceiling are both hard constraints for the surprise
     route; thin combinations show a plain consent screen; the ceiling loosens
     only when the visitor asks
   - the front route never asks about intensity; the result DISCLOSES it
   - pairs rotate within intensity tiers, never repeat as new within a run
   - the Set/Plus note fires when the collection crosses the relevant line */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.chv2Init) return;
    root.dataset.chv2Init = '1';
    var blob = root.querySelector('script[data-chv2-data]');
    if (!blob) return;
    var CFG;
    try { CFG = JSON.parse(blob.textContent); } catch (e) { if (window.console) console.error('[flipsi] chooser v2: bad JSON', e); return; }
    var COPY = CFG.copy || {};
    var ITEMS = {}, COLLS = {}, FAM = {};
    (CFG.items || []).forEach(function (it) {
      if (!it.key) return;
      ITEMS[it.key] = it;
      it.tier = { gentle: 0, eerie: 1, dark: 2 }[it.tier] || 0;
      it.feels = (it.feels || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      (COLLS[it.collKey] = COLLS[it.collKey] || []).push(it.key);
    });
    (CFG.families || []).forEach(function (f) { if (f.collKey) FAM[f.collKey] = f; });
    var TIER_LABEL = ['Gentle', 'Eerie', 'Properly dark'];
    var BOUND_WORD = { 0: 'keep it gentle', 1: 'a little eerie', 2: 'properly dark' };

    var sheet = root.querySelector('[data-chv2-sheet]');
    var scrim = root.querySelector('[data-chv2-scrim]');
    var scr = root.querySelector('[data-chv2-screen]');
    var body = root.querySelector('[data-chv2-body]');
    var dots = root.querySelectorAll('[data-chv2-dots] i');
    if (!sheet || !scr) return;

    var st, opener = null;
    function reset() {
      st = { route: null, feel: null, bound: null, ceiling: 0, childNote: false, keptGentle: false, loosened: false,
        pool: [], pairs: [], pairIdx: 0, seen: {}, pick: null, altId: null, picks: [], runners: [] };
    }
    reset();
    function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
    function ceilOf(b) { return b === 'child' ? 0 : { gentle: 0, eerie: 1, dark: 2 }[b]; }
    function eligible(feel, ceiling) {
      return Object.keys(ITEMS).filter(function (k) {
        var it = ITEMS[k];
        if (it.tier > ceiling) return false;
        if (feel === 'showme') return true;
        return it.feels.indexOf(feel) >= 0;
      });
    }
    function orderPool(ids) { return ids.slice().sort(function (a, b) { return ITEMS[b].tier - ITEMS[a].tier; }); }
    function buildPairs() {
      var ids = st.pool.filter(function (k) { return !st.seen[k]; });
      if (ids.length < 1) { st.pairs = []; st.pairIdx = 0; return; }
      var out = [];
      [2, 1, 0].forEach(function (t) {
        var g = ids.filter(function (k) { return ITEMS[k].tier === t; });
        if (!g.length) return;
        var off = Math.floor(Math.random() * g.length);
        out = out.concat(g.slice(off), g.slice(0, off));
      });
      ids = out;
      if (ids.length > 1 && ITEMS[ids[0]].collKey === ITEMS[ids[1]].collKey) {
        for (var i = 2; i < ids.length; i++) {
          if (ITEMS[ids[i]].tier !== ITEMS[ids[1]].tier) break;
          if (ITEMS[ids[i]].collKey !== ITEMS[ids[0]].collKey) { var t2 = ids[1]; ids[1] = ids[i]; ids[i] = t2; break; }
        }
      }
      st.pairs = []; for (var j = 0; j + 1 < ids.length; j += 2) { st.pairs.push([ids[j], ids[j + 1]]); }
      if (ids.length % 2 === 1) { st.pairs.push([ids[ids.length - 1]]); }
      st.pairIdx = 0;
    }
    function buildPairsUnordered() {
      var ids = st.pool.filter(function (k) { return !st.seen[k]; });
      if (ids.length < 1) { st.pairs = []; st.pairIdx = 0; return; }
      for (var i = ids.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = ids[i]; ids[i] = ids[j]; ids[j] = t; }
      if (ids.length > 1 && ITEMS[ids[0]].collKey === ITEMS[ids[1]].collKey) {
        for (var m = 2; m < ids.length; m++) { if (ITEMS[ids[m]].collKey !== ITEMS[ids[0]].collKey) { var t2 = ids[1]; ids[1] = ids[m]; ids[m] = t2; break; } }
      }
      st.pairs = []; for (var p = 0; p + 1 < ids.length; p += 2) { st.pairs.push([ids[p], ids[p + 1]]); }
      if (ids.length % 2 === 1) { st.pairs.push([ids[ids.length - 1]]); }
      st.pairIdx = 0;
    }

    /* ---------- open/close + focus ---------- */
    function focusables() {
      return Array.prototype.slice.call(sheet.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null; });
    }
    function open() {
      opener = (document.activeElement && document.activeElement !== document.body) ? document.activeElement : null;
      sheet.classList.add('is-open'); scrim.classList.add('is-open'); document.body.classList.add('chv2-lock');
      setTimeout(function () {
        if (!sheet.classList.contains('is-open')) return;
        var f = scr.querySelector('button, a[href]'); (f || root.querySelector('[data-chv2-close]')).focus();
      }, 250);
    }
    function close() {
      sheet.classList.remove('is-open'); scrim.classList.remove('is-open'); document.body.classList.remove('chv2-lock');
      if (opener && opener.focus) opener.focus();
    }
    root.querySelector('[data-chv2-close]').addEventListener('click', close);
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (!sheet.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    root.__fsChooserOpen = open;
    window.__fsChooserOpen = open;
    if (!document.body.dataset.chv2Delegate) {
      document.body.dataset.chv2Delegate = '1';
      document.addEventListener('click', function (e) {
        var op = e.target.closest('[data-fs-open]');
        if (!op || op.dataset.fsTriggerBound) return; /* rail binds its own; avoid double-open */
        e.preventDefault(); open();
      }, true);
    }

    function setDots(n) { Array.prototype.forEach.call(dots, function (d, i) { d.classList.toggle('on', i <= n); }); }
    function paint(html, dot) {
      scr.innerHTML = '<div class="chv2-scr">' + html + '</div>';
      setDots(dot); body.scrollTop = 0; bind();
      if (sheet.classList.contains('is-open')) { var f = scr.querySelector('button, a[href]'); if (f) f.focus(); }
    }

    /* ---------- screens ---------- */
    function sIntro() {
      var introImg = COPY.intro_image || (ITEMS[Object.keys(ITEMS)[0]] || {}).img || '';
      paint('<span class="chv2-eyebrow">' + esc(COPY.eyebrow || 'The Flipsi chooser') + '</span>'
        + '<h3 class="chv2-h">' + (COPY.intro_heading || 'Every double-sided Flipsi hides a <em>second artwork.</em>') + '</h3>'
        + '<p class="chv2-sub">' + esc(COPY.intro_sub || 'Tap to flip.') + '</p>'
        + '<div class="chv2-fdemo"><button class="chv2-fcard" data-chv2-flip aria-label="A puzzle front. Press to flip the card over.">'
        + '<div class="f"><img src="' + esc(introImg) + '" alt="' + esc(COPY.intro_image_alt || 'A Flipsi front artwork') + '" loading="eager" decoding="async"></div>'
        + '<div class="b"><div class="chv2-seal" aria-hidden="true">?</div><span>The story continues.</span></div>'
        + '</button></div>'
        + '<p class="chv2-cue" data-chv2-cue>' + esc(COPY.cue_before || 'Go on. Flip it.') + '</p>'
        + '<div class="chv2-chips">'
        + '<button class="chv2-chip" data-route="front"><b>' + esc(COPY.fork_front_label || 'Start with the front') + '</b><span>' + esc(COPY.fork_front_sub || 'Choose by the artwork you want to build.') + '</span></button>'
        + '<button class="chv2-chip" data-route="surprise"><b>' + esc(COPY.fork_surprise_label || 'Start with the surprise') + '</b><span>' + esc(COPY.fork_surprise_sub || 'Choose by the kind of reveal you want. No spoilers.') + '</span></button>'
        + '</div>'
        + '<p class="chv2-childline">' + esc(COPY.fork_child_line || "Buying for a child? Start with the surprise: we'll keep to gentler options.") + '</p>', 0);
      var fc = scr.querySelector('[data-chv2-flip]'), flipped = false;
      if (fc) fc.addEventListener('click', function () {
        flipped = !flipped; fc.classList.toggle('flip', flipped);
        scr.querySelector('[data-chv2-cue]').textContent = flipped ? (COPY.cue_after || 'Still sealed. We never show the other side here.') : (COPY.cue_before || 'Go on. Flip it.');
      });
    }
    function buildFrontPairs() { st.pool = Object.keys(ITEMS); buildPairsUnordered(); }
    function sFrontPull() {
      var round = st.picks.length + 1;
      var pr = st.pairs[st.pairIdx];
      var html = '<span class="chv2-eyebrow">Round ' + round + ' of three</span>'
        + '<h3 class="chv2-h">Which front <em>pulls you in?</em></h3>'
        + '<p class="chv2-sub">Fronts only, as always. Pick the one you’d choose first.</p>';
      if (pr && pr.length === 2) {
        var A = ITEMS[pr[0]], B = ITEMS[pr[1]];
        html += '<div class="chv2-roundk">' + esc(A.coll) + ' · versus · ' + esc(B.coll) + '</div>'
          + '<div class="chv2-pair">'
          + '<button class="chv2-pcard" data-fpick="' + pr[0] + '"><div class="chv2-pwell"><img src="' + esc(A.img) + '" alt="' + esc('Front artwork of ' + A.n) + '" loading="eager" decoding="async"></div><div class="chv2-pcap">' + esc(A.line) + '</div></button>'
          + '<button class="chv2-pcard" data-fpick="' + pr[1] + '"><div class="chv2-pwell"><img src="' + esc(B.img) + '" alt="' + esc('Front artwork of ' + B.n) + '" loading="eager" decoding="async"></div><div class="chv2-pcap">' + esc(B.line) + '</div></button>'
          + '</div>'
          + '<button class="chv2-backlink chv2-neither" data-nav="fneither">Neither. Show me another pair →</button>';
      } else if (pr && pr.length === 1) {
        var S = ITEMS[pr[0]];
        html += '<div class="chv2-note">One front left that you haven’t seen.</div>'
          + '<div class="chv2-pair" style="grid-template-columns:1fr; max-width:320px; margin:0 auto;">'
          + '<button class="chv2-pcard" data-fpick="' + pr[0] + '"><div class="chv2-pwell"><img src="' + esc(S.img) + '" alt="' + esc('Front artwork of ' + S.n) + '" loading="eager" decoding="async"></div><div class="chv2-pcap">' + esc(S.line) + '</div></button>'
          + '</div>';
      } else {
        if (st.picks.length > 0) { sFavourite(); return; }
        html += '<div class="chv2-note">You’ve seen every front we make.</div>'
          + '<div class="chv2-chips">'
          + '<button class="chv2-chip" data-nav="restart"><b>Start over</b><span>Back to the beginning.</span></button>'
          + '<button class="chv2-chip" data-nav="browse"><b>I’ll browse the worlds myself</b><span>Also a fine way to choose.</span></button>'
          + '</div>';
      }
      html += '<div class="chv2-backrow"><button class="chv2-backlink" data-nav="restart">← Start over</button></div>';
      paint(html, Math.min(round, 3));
    }
    function sFavourite() {
      if (st.picks.length === 1) { st.pick = st.picks[0]; st.altId = null; st.runners = []; sResult(); return; }
      var html = '<span class="chv2-eyebrow">Your picks</span>'
        + '<h3 class="chv2-h">Which one would <em>you choose?</em></h3>'
        + '<p class="chv2-sub">Your ' + (st.picks.length === 3 ? 'three' : 'two') + ' picks, side by side.</p>'
        + '<div class="' + (st.picks.length === 3 ? 'chv2-triple' : 'chv2-pair') + '">';
      st.picks.forEach(function (k) {
        var it = ITEMS[k];
        html += '<button class="chv2-pcard" data-fav="' + k + '"><div class="chv2-pwell"><img src="' + esc(it.img) + '" alt="' + esc('Front artwork of ' + it.n) + '" loading="eager" decoding="async"></div><div class="chv2-pcap">' + esc(it.line) + '</div></button>';
      });
      html += '</div><div class="chv2-backrow"><button class="chv2-backlink" data-nav="restart">← Start over</button></div>';
      paint(html, 3);
    }
    function sFeeling() {
      paint('<span class="chv2-eyebrow">One of three</span>'
        + '<h3 class="chv2-h">What are you in the <em>mood for?</em></h3>'
        + '<p class="chv2-sub">Every Flipsi hides a second artwork on the back: build the front, flip it, and find out. So start with the feeling you’re after.</p>'
        + '<div class="chv2-chips">'
        + '<button class="chv2-chip" data-feel="shiver"><b>A shiver</b><span>Something atmospheric, eerie, or properly dark.</span></button>'
        + '<button class="chv2-chip" data-feel="away"><b>Somewhere else entirely</b><span>Wonder, escape, another world.</span></button>'
        + '<button class="chv2-chip" data-feel="grin"><b>Something playful</b><span>Mischief, humour, and a little trouble.</span></button>'
        + '<button class="chv2-chip" data-feel="showme"><b>Choose for me</b><span>Fair. The artwork will do the talking.</span></button>'
        + '</div>'
        + '<div class="chv2-backrow"><button class="chv2-backlink" data-nav="intro">← Back</button></div>', 1);
    }
    function sBoundary() {
      var head = 'How far should we <em>take it?</em>';
      var sub = 'Some of our hidden sides stay gentle. Some are eerie. Some go properly dark. Tell us where your line is.';
      if (st.feel === 'shiver') sub = 'From atmospheric to properly dark, tell us where your line is.';
      else if (st.feel === 'away') sub = 'Some escapes stay gentle. Some have an eerie edge. Tell us where your line is.';
      else if (st.feel === 'grin') sub = 'The playful options can still get dark. Tell us where your line is.';
      else if (st.feel === 'showme') { head = 'Anything we should <em>avoid?</em>'; sub = 'Give us the boundary and we’ll choose from there.'; }
      paint('<span class="chv2-eyebrow">Two of three</span>'
        + '<h3 class="chv2-h">' + head + '</h3>'
        + '<p class="chv2-sub">' + sub + '</p>'
        + '<div class="chv2-chips">'
        + '<button class="chv2-chip" data-bound="gentle"><b>Keep it gentle</b><span>Beautiful, strange or surprising. Nothing frightening.</span></button>'
        + '<button class="chv2-chip" data-bound="eerie"><b>A little eerie is good</b><span>Atmosphere and a shiver, without going properly dark.</span></button>'
        + '<button class="chv2-chip" data-bound="dark"><b>Properly dark is fine</b><span>Don’t soften it on our account.</span></button>'
        + '<button class="chv2-chip" data-bound="child"><b>It’s for a child</b><span>We’ll keep to gentler options and tell you how to check first.</span></button>'
        + '</div>'
        + '<div class="chv2-backrow"><button class="chv2-backlink" data-nav="feeling">← Back</button></div>', 2);
    }
    function afterBoundary() {
      st.ceiling = ceilOf(st.bound);
      st.childNote = st.bound === 'child';
      var ids = eligible(st.feel, st.ceiling);
      if ((st.feel === 'shiver' || st.feel === 'grin') && ids.length === 0) {
        var isShiver = st.feel === 'shiver';
        var childLine = st.bound === 'child'
          ? '<p class="chv2-sub">Our ' + (isShiver ? 'shivers run' : 'mischief runs') + ' eerie to properly dark: more than we’d choose for a child. Here’s what we’d do instead.</p>'
          : '<p class="chv2-sub">We don’t really make ' + (isShiver ? 'a completely gentle shiver' : 'completely gentle mischief') + '. So it’s your call.</p>';
        var loosen = '';
        if (st.bound !== 'child') {
          loosen = isShiver
            ? '<button class="chv2-chip" data-consent="theatrical"><b>A theatrical shiver is okay</b><span>Unlocks our gentlest eerie fronts: stagey, not nightmarish.</span></button>'
            : '<button class="chv2-chip" data-consent="eeriegrin"><b>A little eerie mischief is okay</b><span>Unlocks our eerie mischief.</span></button>';
        }
        paint('<span class="chv2-eyebrow">Before the artwork</span>'
          + '<h3 class="chv2-h">' + (isShiver ? 'A shiver, kept <em>gentle?</em>' : 'Playful, kept <em>gentle?</em>') + '</h3>'
          + childLine
          + '<div class="chv2-chips">'
          + '<button class="chv2-chip" data-consent="gentle"><b>Keep it completely gentle</b><span>We’ll show the closest gentle worlds.</span></button>'
          + loosen + '</div>'
          + '<div class="chv2-backrow"><button class="chv2-backlink" data-nav="boundary">← Back</button></div>', 3);
        return;
      }
      st.pool = orderPool(ids);
      buildPairs();
      sPull();
    }
    function sPull() {
      var pr = st.pairs[st.pairIdx];
      var html = '<span class="chv2-eyebrow">Three of three</span>'
        + '<h3 class="chv2-h">Which front <em>pulls you in?</em></h3>'
        + '<p class="chv2-sub">Fronts only, as always. Pick the one you’d choose first.</p>';
      var hasDarkAway = Object.keys(ITEMS).some(function (k) { return ITEMS[k].tier === 2 && ITEMS[k].feels.indexOf('away') >= 0; });
      if (st.feel === 'away' && st.bound === 'dark' && st.pairIdx === 0 && !hasDarkAway) {
        html += '<div class="chv2-note">None of our escapes go properly dark. The pirate worlds come closest: eerie, and adventure first.</div>';
      }
      if (pr && pr.length === 2) {
        var A = ITEMS[pr[0]], B = ITEMS[pr[1]];
        html += '<div class="chv2-roundk">' + esc(A.coll) + ' · versus · ' + esc(B.coll) + '</div>'
          + '<div class="chv2-pair">'
          + '<button class="chv2-pcard" data-pick="' + pr[0] + '" data-alt="' + pr[1] + '"><div class="chv2-pwell"><img src="' + esc(A.img) + '" alt="' + esc('Front artwork of ' + A.n) + '" loading="eager" decoding="async"></div><div class="chv2-pcap">' + esc(A.line) + '</div></button>'
          + '<button class="chv2-pcard" data-pick="' + pr[1] + '" data-alt="' + pr[0] + '"><div class="chv2-pwell"><img src="' + esc(B.img) + '" alt="' + esc('Front artwork of ' + B.n) + '" loading="eager" decoding="async"></div><div class="chv2-pcap">' + esc(B.line) + '</div></button>'
          + '</div>'
          + '<button class="chv2-backlink chv2-neither" data-nav="neither">Neither. Show me another pair →</button>';
      } else if (pr && pr.length === 1) {
        var S = ITEMS[pr[0]];
        html += '<div class="chv2-note">One front fits what you’ve asked for, so there’s nothing left to compare it against.</div>'
          + '<div class="chv2-pair" style="grid-template-columns:1fr; max-width:320px; margin:0 auto;">'
          + '<button class="chv2-pcard" data-pick="' + pr[0] + '" data-alt=""><div class="chv2-pwell"><img src="' + esc(S.img) + '" alt="' + esc('Front artwork of ' + S.n) + '" loading="eager" decoding="async"></div><div class="chv2-pcap">' + esc(S.line) + '</div></button>'
          + '</div>';
      } else {
        html += '<div class="chv2-note">You’ve seen every front that fits what you asked for.</div>'
          + '<div class="chv2-chips">'
          + (st.ceiling < 2 && st.bound !== 'child' ? '<button class="chv2-chip" data-adjust="darker"><b>Loosen the line: a little darker is okay</b><span>We’ll bring in the next shelf up.</span></button>' : '')
          + (st.ceiling > 0 ? '<button class="chv2-chip" data-adjust="gentler"><b>Loosen it the other way: gentler</b><span>Same idea, softer.</span></button>' : '')
          + '<button class="chv2-chip" data-nav="feeling"><b>Change what I’m after</b><span>Back to the first question.</span></button>'
          + '<button class="chv2-chip" data-nav="browse"><b>I’ll browse the worlds myself</b><span>Also a fine way to choose.</span></button>'
          + '</div>';
      }
      html += '<div class="chv2-backrow"><button class="chv2-backlink" data-nav="boundary">← Back</button></div>';
      paint(html, 3);
    }
    function reasoning() {
      var it = ITEMS[st.pick];
      if (st.route === 'front') {
        if (st.runners && st.runners.length) return 'You chose by the front, and of everything you saw, ' + it.short + ' kept winning. We’d start with ' + it.n + '.';
        return 'You chose by the front, and ' + it.short + ' was the one that pulled you. We’d start with ' + it.n + '.';
      }
      var openers = { shiver: 'You wanted a shiver', away: 'You wanted somewhere else entirely', grin: 'You wanted something playful', showme: 'You asked us to let the artwork lead' };
      var s;
      if (st.keptGentle) { s = 'You wanted to keep things completely gentle'; }
      else {
        s = openers[st.feel];
        if (st.bound === 'eerie') s += ', but nothing properly dark';
        else if (st.bound === 'dark') s += ' and you’re happy to go properly dark';
        else if (st.bound === 'gentle') s += ' and wanted to keep it gentle';
        else if (st.bound === 'child') s += ', choosing for a child';
        if (st.loosened) s += ', with a theatrical shiver allowed';
      }
      if (st.altId) { s += ', and ' + it.short + ' pulled you in more than ' + ITEMS[st.altId].short + '.'; }
      else { s += ', and one front fits that best.'; }
      s += ' We’d start with ' + it.n + '.';
      return s;
    }
    function sResult() {
      var it = ITEMS[st.pick];
      var alt = st.altId ? ITEMS[st.altId] : null;
      var collIds = COLLS[it.collKey] || [st.pick];
      var siblings = collIds.filter(function (k) { return k !== st.pick; });
      var setMax = Math.max.apply(null, collIds.map(function (k) { return ITEMS[k].tier; }));
      var isFront = st.route === 'front';
      var warnCeil = isFront ? it.tier : st.ceiling;
      var exceeds = setMax > warnCeil;
      var mixed = collIds.some(function (k) { return ITEMS[k].tier !== it.tier; });
      var fam = FAM[it.collKey] || {};
      var collUrl = fam.collUrl || '#';

      var html = '<span class="chv2-eyebrow">Where we’d start</span>'
        + '<h3 class="chv2-h">Start with <em>' + esc(it.n) + '.</em></h3>'
        + '<div class="chv2-rwell"><img src="' + esc(it.img) + '" alt="' + esc('Front artwork of ' + it.n) + '" loading="eager" decoding="async"></div>'
        + '<span class="chv2-rk">' + esc(it.coll) + '</span>'
        + '<div class="chv2-rline">' + esc(it.line) + '</div>'
        + '<p class="chv2-rwhy">' + reasoning() + '</p>';
      if (isFront) {
        html += '<div class="chv2-revline"><span class="chv2-tchip' + (it.tier === 2 ? ' chv2-tchip--dark' : '') + '">' + TIER_LABEL[it.tier] + '</span>'
          + '<span>' + (it.tier === 2 ? 'Its hidden side goes properly dark.' : it.tier === 1 ? 'Its hidden side is eerie.' : 'Its hidden side stays gentle.') + '</span></div>';
      }
      if (st.childNote) html += '<div class="chv2-note" style="margin-top:14px;"><b>Buying for a child?</b> ' + esc(COPY.child_note || 'Tell us what you need to avoid and we’ll help you choose privately. You keep the secret; they get the moment.') + '</div>';
      if (it.twin) html += '<div class="chv2-note" style="margin-top:14px;"><b>About the Twin:</b> it’s two puzzles. One stays cosy; the other runs properly dark. That contrast is the point.</div>';
      if (alt) {
        html += '<div class="chv2-altcard"><div class="chv2-altwell"><img src="' + esc(alt.img) + '" alt="' + esc('Front artwork of ' + alt.n) + '" loading="eager" decoding="async"></div>'
          + '<div class="chv2-altbody"><span class="chv2-rk">Also worth a look</span><b>' + esc(alt.n) + ' · ' + esc(alt.coll) + '</b>'
          + '<p>' + esc(alt.adj) + '</p></div></div>';
      }
      if (isFront && st.runners && st.runners.length) {
        st.runners.forEach(function (rk) {
          var r = ITEMS[rk];
          html += '<div class="chv2-altcard"><div class="chv2-altwell"><img src="' + esc(r.img) + '" alt="' + esc('Front artwork of ' + r.n) + '" loading="eager" decoding="async"></div>'
            + '<div class="chv2-altbody"><span class="chv2-rk">Also pulled you</span><b>' + esc(r.n) + ' · ' + esc(r.coll) + '</b>'
            + '<p>' + esc(r.adj) + '</p></div></div>';
        });
      }
      if (!isFront && st.feel === 'grin' && st.ceiling === 1 && !it.twin) {
        var tw = null;
        Object.keys(ITEMS).forEach(function (k) { if (ITEMS[k].twin) tw = ITEMS[k]; });
        if (tw) {
          html += '<div class="chv2-altcard"><div class="chv2-altwell"><img src="' + esc(tw.img) + '" alt="' + esc('Front artwork of ' + tw.n) + '" loading="eager" decoding="async"></div>'
            + '<div class="chv2-altbody"><span class="chv2-rk">Past your line, if you want it</span><b>' + esc(tw.n) + ' · ' + esc(tw.coll) + '</b>'
            + '<p>' + esc(tw.adj) + ' Only worth it if you’re happy to go darker than you said.</p></div></div>';
        }
      }
      var bword = st.bound === 'child' ? 'gentle' : (st.bound === 'dark' ? 'dark' : st.bound);
      html += '<div class="chv2-adjust">'
        + '<a class="yes" href="' + esc(it.url || '#') + '">View ' + esc(it.n) + '</a>'
        + '<a href="' + esc(collUrl) + '">Explore ' + esc(it.coll) + '</a>'
        + '</div><div class="chv2-adjust" style="margin-top:8px;">'
        + (isFront ? '<button data-nav="fmore">Show me more fronts</button>'
          : '<button data-nav="anotherpair">Show me another pair</button>'
          + (st.ceiling < 2 && st.bound !== 'child' ? '<button data-adjust="darker">A little darker</button>' : '')
          + (st.ceiling > 0 ? '<button data-adjust="gentler">A little gentler</button>' : ''))
        + '</div>';
      if (siblings.length) {
        html += '<div class="chv2-ctx"><span class="chv2-buyk">More from ' + esc(it.coll) + '</span>'
          + (mixed ? '<p class="chv2-ctxsub">They share a world. They don’t all have the same level of fright.</p>' : '')
          + '<div class="chv2-ctxgrid">';
        siblings.forEach(function (k) {
          var s = ITEMS[k];
          html += '<div class="chv2-ctxc"><div class="chv2-ctxwell"><img src="' + esc(s.img) + '" alt="' + esc('Front artwork of ' + s.n) + '" loading="eager" decoding="async"></div>'
            + '<div class="chv2-ctxb"><b>' + esc(s.n) + '</b><span class="chv2-tchip' + (s.tier === 2 ? ' chv2-tchip--dark' : '') + '">' + TIER_LABEL[s.tier] + '</span></div></div>';
        });
        html += '</div></div>';
      }
      var warn = '';
      if (exceeds && !it.twin && fam.set) {
        warn = isFront
          ? '<div class="chv2-warn"><b>One thing to know before choosing the Set:</b> not every puzzle in ' + esc(it.coll) + ' stays at the intensity of ' + esc(it.n) + '. Some go properly dark. The intensity labels above show which.</div>'
          : '<div class="chv2-warn"><b>One thing to know before choosing the Set:</b> not every puzzle in ' + esc(it.coll) + ' stays at the same intensity. Some go properly dark. If you want to stay with “' + BOUND_WORD[st.ceiling] + '”, the Single is the better fit.</div>';
      }
      html += '<div class="chv2-buy">'
        + '<span class="chv2-buyk">How much of ' + esc(it.coll) + ' do you want to take home?</span>';
      if (it.twin) {
        html += '<a class="row" href="' + esc(it.url || '#') + '"><b>The Twin Pack</b><i>two boxes, four artworks, two secrets</i><span class="pr">' + esc(it.price) + '</span></a>';
        if (fam.board) html += '<a class="row" href="' + esc(fam.board.url) + '"><b>Add the Flipsi Board</b><i>optional; makes the flip one smooth move</i><span class="pr">' + esc(fam.board.price) + '</span></a>';
      } else {
        html += '<a class="row" href="' + esc(it.url || '#') + '"><b>One puzzle</b><i>' + esc(it.n) + ', on its own</i><span class="pr">' + esc(it.price) + '</span></a>'
          + warn
          + (fam.set ? '<a class="row" href="' + esc(fam.set.url) + '"><b>The Set</b><i>all three ' + esc(it.coll) + ' puzzles</i><span class="pr">' + esc(fam.set.price) + '</span>' + (exceeds ? '<span class="chv2-badge">Includes darker puzzles</span>' : '') + '</a>' : '')
          + (fam.plus ? '<a class="row" href="' + esc(fam.plus.url) + '"><b>Flipsi Plus</b><i>the Set + Flipsi Board</i><span class="pr">' + esc(fam.plus.price) + '</span>' + (exceeds ? '<span class="chv2-badge">Includes darker puzzles</span>' : '') + '</a>' : '')
          + '<button class="row" data-nav="compare"><b>Help me compare</b><i>Single, Set or Plus in three lines</i></button>'
          + '<div class="chv2-cmp" data-chv2-cmp>Want one puzzle? Choose the <b>Single</b>.<br>Want all three puzzles in the collection? Choose the <b>Set</b>.<br>Want all three plus the Flipsi Board? Choose <b>Plus</b>.</div>';
      }
      html += '</div>'
        + '<div class="chv2-backrow"><button class="chv2-backlink" data-nav="restart">Start over</button>'
        + '<a class="chv2-backlink" href="' + esc(COPY.browse_url || '/collections/all') + '">Browse everything instead →</a></div>';
      paint(html, 4);
    }

    /* ---------- wiring ---------- */
    function bind() {
      scr.querySelectorAll('[data-route]').forEach(function (el) {
        el.addEventListener('click', function () {
          var r = el.dataset.route; reset(); st.route = r;
          if (r === 'front') { buildFrontPairs(); sFrontPull(); } else { sFeeling(); }
        });
      });
      scr.querySelectorAll('[data-fpick]').forEach(function (el) {
        el.addEventListener('click', function () {
          var pr = st.pairs[st.pairIdx] || [];
          pr.forEach(function (x) { st.seen[x] = 1; });
          st.picks.push(el.dataset.fpick);
          st.pairIdx++;
          if (st.picks.length >= 3 || st.pairIdx >= st.pairs.length) { sFavourite(); } else { sFrontPull(); }
        });
      });
      scr.querySelectorAll('[data-fav]').forEach(function (el) {
        el.addEventListener('click', function () {
          st.pick = el.dataset.fav;
          st.runners = st.picks.filter(function (k) { return k !== st.pick; });
          st.altId = null; sResult();
        });
      });
      scr.querySelectorAll('[data-feel]').forEach(function (el) {
        el.addEventListener('click', function () { var rt = st.route; reset(); st.route = rt; st.feel = el.dataset.feel; sBoundary(); });
      });
      scr.querySelectorAll('[data-bound]').forEach(function (el) {
        el.addEventListener('click', function () { st.bound = el.dataset.bound; st.keptGentle = false; st.loosened = false; st.seen = {}; afterBoundary(); });
      });
      scr.querySelectorAll('[data-consent]').forEach(function (el) {
        el.addEventListener('click', function () {
          var c = el.dataset.consent;
          if (c === 'gentle') { st.keptGentle = true; st.pool = orderPool(eligible('showme', 0)); }
          else if (c === 'theatrical') {
            st.loosened = true; st.ceiling = 1;
            st.pool = Object.keys(ITEMS).filter(function (k) {
              var i2 = ITEMS[k]; return i2.tier === 1 && i2.feels.indexOf('shiver') >= 0 && i2.feels.indexOf('away') < 0;
            });
          }
          else if (c === 'eeriegrin') {
            st.ceiling = 1;
            st.pool = Object.keys(ITEMS).filter(function (k) { var i2 = ITEMS[k]; return i2.tier === 1 && i2.feels.indexOf('grin') >= 0 && !i2.twin; });
          }
          buildPairs(); sPull();
        });
      });
      scr.querySelectorAll('[data-pick]').forEach(function (el) {
        el.addEventListener('click', function () {
          st.pick = el.dataset.pick; st.altId = el.dataset.alt || null;
          st.seen[st.pick] = 1; if (st.altId) st.seen[st.altId] = 1;
          sResult();
        });
      });
      scr.querySelectorAll('[data-adjust]').forEach(function (el) {
        el.addEventListener('click', function () {
          var dir = el.dataset.adjust;
          st.ceiling = dir === 'darker' ? Math.min(2, st.ceiling + 1) : Math.max(0, st.ceiling - 1);
          st.bound = ['gentle', 'eerie', 'dark'][st.ceiling];
          st.loosened = false; st.keptGentle = st.keptGentle && st.ceiling === 0;
          var feel = st.keptGentle ? 'showme' : st.feel;
          st.pool = orderPool(eligible(feel, st.ceiling));
          st.seen = {}; buildPairs(); sPull();
        });
      });
      scr.querySelectorAll('[data-nav]').forEach(function (el) {
        el.addEventListener('click', function () {
          var n = el.dataset.nav;
          if (n === 'intro') { reset(); sIntro(); }
          else if (n === 'feeling') { var rt = st.route; reset(); st.route = rt; sFeeling(); }
          else if (n === 'boundary') { st.seen = {}; sBoundary(); }
          else if (n === 'neither') {
            var pr = st.pairs[st.pairIdx] || [];
            pr.forEach(function (k) { st.seen[k] = 1; });
            st.pairIdx++;
            if (st.pairIdx >= st.pairs.length) { buildPairs(); }
            sPull();
          }
          else if (n === 'fneither') {
            var prf = st.pairs[st.pairIdx] || [];
            prf.forEach(function (k) { st.seen[k] = 1; });
            st.pairIdx++;
            if (st.pairIdx >= st.pairs.length) { buildPairsUnordered(); }
            sFrontPull();
          }
          else if (n === 'anotherpair') { buildPairs(); sPull(); }
          else if (n === 'fmore') { st.picks = []; st.runners = []; buildPairsUnordered(); sFrontPull(); }
          else if (n === 'compare') { var c = scr.querySelector('[data-chv2-cmp]'); if (c) c.classList.add('on'); }
          else if (n === 'browse') { close(); }
          else if (n === 'restart') { reset(); sIntro(); }
        });
      });
    }
    sIntro();
  }
  function boot() {
    document.querySelectorAll('[data-flipsi-chv2]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
